import Swal from 'sweetalert2';
import { isValidProjectLeadEmail } from './partnerValidation';

export const promptForValidProjectLeadEmail = async (currentValue = '') => {
  const result = await Swal.fire({
    title: 'Invalid project lead email',
    html: 'Project lead email must contain <strong>@</strong> and <strong>.</strong><br />Example: <em>name@company.com</em>',
    input: 'email',
    inputValue: currentValue,
    inputPlaceholder: 'email@yourcompany.com',
    showCancelButton: true,
    confirmButtonText: 'Use this email',
    confirmButtonColor: '#052140',
    cancelButtonText: 'Cancel',
    customClass: {
      title: 'swal-title-custom',
      htmlContainer: 'swal-text-custom',
    },
    inputValidator: (value) => {
      if (!isValidProjectLeadEmail(value)) {
        return 'Enter a valid email with @ and .';
      }
      return undefined;
    },
  });

  if (result.isConfirmed && result.value) {
    return result.value.trim();
  }

  return null;
};
